import { render, staticRenderFns } from "./InventoryCountItemsStatus.vue?vue&type=template&id=64710e24&scoped=true&"
import script from "./InventoryCountItemsStatus.vue?vue&type=script&lang=ts&"
export * from "./InventoryCountItemsStatus.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryCountItemsStatus.vue?vue&type=style&index=0&id=64710e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64710e24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
